<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户ID ｛user.id｝" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID ｛user.id｝" />
      </a-form-model-item>
      <a-form-model-item label="计划日期 {plan_day.id}" prop="planDayId" >
        <a-input v-model="form.planDayId" placeholder="请输入计划日期 {plan_day.id}" />
      </a-form-model-item>
      <a-form-model-item label="早餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]" prop="breakfast" >
        <a-input v-model="form.breakfast" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="午餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]" prop="lunch" >
        <a-input v-model="form.lunch" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="晚餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]" prop="dinner" >
        <a-input v-model="form.dinner" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="计划日期" prop="planDate" >
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDayDiet, addDayDiet, updateDayDiet } from '@/api/user/dayDiet'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        planDayId: null,

        breakfast: null,

        lunch: null,

        dinner: null,

        planDate: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID ｛user.id｝不能为空', trigger: 'blur' }
        ],
        planDayId: [
          { required: true, message: '计划日期 {plan_day.id}不能为空', trigger: 'blur' }
        ],
        breakfast: [
          { required: true, message: '早餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]不能为空', trigger: 'blur' }
        ],
        lunch: [
          { required: true, message: '午餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]不能为空', trigger: 'blur' }
        ],
        dinner: [
          { required: true, message: '晚餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]不能为空', trigger: 'blur' }
        ],
        planDate: [
          { required: true, message: '计划日期不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        planDayId: null,
        breakfast: null,
        lunch: null,
        dinner: null,
        planDate: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDayDiet({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDayDiet(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDayDiet(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
